<template>
  <el-dialog
    title="LOG记录查看"
    :visible.sync="currentVisible"
    width="50%">
    <p v-html="log"></p>
    <span slot="footer"
          class="dialog-footer">
    </span>
  </el-dialog>
</template>

<script>
export default {
  components: {},
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: false,
    },
  },
  data () {
    return {
      currentVisible: this.visible,
      log: '',
    }
  },
  computed: {},
  watch: {
    visible () {
      if (this.currentVisible !== this.visible) {
        this.log = null
        this.currentVisible = this.visible
        if (this.currentVisible) {
          this.getLog()
        }
      }
    },
    currentVisible () {
      if (this.currentVisible !== this.visible) {
        this.$emit('update:visible', this.currentVisible)
      }
    },
  },
  created () {
  },
  mounted () {},
  methods: {
    getLog () {
      request.common('getStepTemplateLog', {id: this.id}).then(({data}) => {
        this.log = data
      })
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/step-template/components/StepTemplateLog.vue